import axios from "axios";
import { AgreementPayload } from "../models/response/AgreementPayload";
import client from "../client";

export function get() {
    return client.get<AgreementPayload>(`/Agreements/ByType/1`, {
      headers: {accept: 'application/json'},
    })
  }
